var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FFD4DF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97631 14.3096C5.60143 13.6844 6.44928 13.3333 7.33333 13.3333H12C12.8841 13.3333 13.7319 13.6844 14.357 14.3096C14.9821 14.9347 15.3333 15.7825 15.3333 16.6666V17.9999C15.3333 18.3681 15.0349 18.6666 14.6667 18.6666C14.2985 18.6666 14 18.3681 14 17.9999V16.6666C14 16.1362 13.7893 15.6274 13.4142 15.2524C13.0391 14.8773 12.5304 14.6666 12 14.6666H7.33333C6.8029 14.6666 6.29419 14.8773 5.91912 15.2524C5.54405 15.6274 5.33333 16.1362 5.33333 16.6666V17.9999C5.33333 18.3681 5.03486 18.6666 4.66667 18.6666C4.29848 18.6666 4 18.3681 4 17.9999V16.6666C4 15.7825 4.35119 14.9347 4.97631 14.3096Z",
    fill: "#FF406E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66634 6.66659C8.56177 6.66659 7.66634 7.56202 7.66634 8.66658C7.66634 9.77115 8.56177 10.6666 9.66634 10.6666C10.7709 10.6666 11.6663 9.77115 11.6663 8.66658C11.6663 7.56202 10.7709 6.66659 9.66634 6.66659ZM6.33301 8.66658C6.33301 6.82564 7.82539 5.33325 9.66634 5.33325C11.5073 5.33325 12.9997 6.82564 12.9997 8.66658C12.9997 10.5075 11.5073 11.9999 9.66634 11.9999C7.82539 11.9999 6.33301 10.5075 6.33301 8.66658Z",
    fill: "#FF406E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5283 8.86201C15.7886 8.60166 16.2107 8.60166 16.4711 8.86201L19.8044 12.1953C20.0648 12.4557 20.0648 12.8778 19.8044 13.1382C19.5441 13.3985 19.122 13.3985 18.8616 13.1382L15.5283 9.80482C15.2679 9.54447 15.2679 9.12236 15.5283 8.86201Z",
    fill: "#FF406E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8044 8.86201C20.0648 9.12236 20.0648 9.54447 19.8044 9.80482L16.4711 13.1382C16.2107 13.3985 15.7886 13.3985 15.5283 13.1382C15.2679 12.8778 15.2679 12.4557 15.5283 12.1953L18.8616 8.86201C19.122 8.60166 19.5441 8.60166 19.8044 8.86201Z",
    fill: "#FF406E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/cancellation.191f34d953289dbf30110cb0f742179e.svg";
export { ForwardRef as ReactComponent };